import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";
import Title from "../Title";

import {Swiper, SwiperSlide} from 'swiper/react';
import swiper, {Autoplay, Navigation, Pagination, EffectFade} from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "swiper/css/effect-fade";
import 'swiper/css/scrollbar';
import ReactHtmlParser from "react-html-parser";
import {bold, darkBlue, hover, white} from "../../styles/globalStyleVars";

const MyComponent = ({bgcolor, data,id , no_slider}) => {


    const slide = data?.posts?.list;


    const nextRef = useRef()
    const prevRef = useRef()
    const [current, setCurrent] = useState('1')
    const [now, setNow] = useState(1)
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [offset, setOffset] = useState(90)

    const swiperRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        setCurrentSlide(swiper.current );
    }, [swiper.current]);

    useEffect(() => {
        setOffset(document.querySelector(' .container').offsetLeft)
        window.addEventListener('load', function () {
            setOffset(document.querySelector(' .container').offsetLeft)

        })
        window.addEventListener('resize', function () {
            setOffset(document.querySelector(' .container').offsetLeft)

        })

    }, [data])


    const handleSliderCurrent = () => {
        setTimeout(() => {
            if (document.querySelector('.sustain .swiper-pagination-current')) {
                setCurrent(document.querySelector('.sustain .swiper-pagination-current').innerHTML)
            }
        }, 200)
    }

    const prevBtn=()=>{
        if(now>1){
            setNow(now-1);
        }
    }

    const nextBtn=()=>{
        if(data?.list?.length>now){
            setNow(now+1);
        }
        else {
            setNow(1)
        }
    }

    return (
        <StyledComponent id={id ? id : 'Sustainability'}  className={`${no_slider ? 'no_slide' : null}`} style={{background: bgcolor ? bgcolor : '#F7F4F4'}}      offset={offset}>


            {/*next prev navigation*/}
            <div className="navigation">
                <ul>
                    <li className={'next_swipper'} ref={nextRef} onClick={prevBtn}>
                        <svg id="Prev" xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                             viewBox="0 0 44 44">
                            <g id="Rectangle_492" data-name="Rectangle 492" fill="none"
                               stroke="#fff"
                               stroke-width="1" opacity="0.5">
                                <rect width="44" height="44" rx="22" stroke="none"/>
                                <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                            </g>
                            <g id="Group_4824" data-name="Group 4824" transform="translate(17 17)">
                                <g id="Group_4823" data-name="Group 4823">
                                    <line id="Line_9" data-name="Line 9" x1="5" y2="5" fill="none"
                                          stroke="#fff" strokeLinecap="round" stroke-width="1"/>
                                    <line id="Line_10" data-name="Line 10" x2="5" y2="5"
                                          transform="translate(0 5)" fill="none" stroke="#fff"
                                          strokeLinecap="round" stroke-width="1"/>
                                </g>
                                <line id="Line_11" data-name="Line 11" x1="10"
                                      transform="translate(0 5)"
                                      fill="none" stroke="#fff" strokeLinecap="round"
                                      stroke-width="1"/>
                            </g>
                            <g id="Rectangle_5661" data-name="Rectangle 5661"
                               transform="translate(0 44) rotate(-90)" fill="none" stroke="#fff"
                               stroke-width="1" strokeDasharray="1 140" opacity="0">
                                <rect width="44" height="44" rx="22" stroke="none"/>
                                <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                            </g>
                        </svg>


                    </li>
                    <li className={'prev_swipper'} ref={prevRef} onClick={nextBtn} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                             viewBox="0 0 44 44">
                            <g id="Next" transform="translate(16429 -2014)">
                                <g id="Rectangle_492" data-name="Rectangle 492"
                                   transform="translate(-16429 2014)" fill="none" stroke="#fff"
                                   stroke-width="1" opacity="0.5">
                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                          fill="none"/>
                                </g>
                                <g id="Group_4824" data-name="Group 4824"
                                   transform="translate(-17065.5 434.5)">
                                    <g id="Group_4823" data-name="Group 4823"
                                       transform="translate(11 4)">
                                        <line id="Line_9" data-name="Line 9" x2="5" y2="5"
                                              transform="translate(647.5 1592.5)" fill="none"
                                              stroke="#fff"
                                              strokeLinecap="round" stroke-width="1"/>
                                        <line id="Line_10" data-name="Line 10" x1="5" y2="5"
                                              transform="translate(647.5 1597.5)" fill="none"
                                              stroke="#fff"
                                              strokeLinecap="round" stroke-width="1"/>
                                    </g>
                                    <line id="Line_11" data-name="Line 11" x2="10"
                                          transform="translate(653.5 1601.5)" fill="none"
                                          stroke="#fff"
                                          strokeLinecap="round" stroke-width="1"/>
                                </g>
                                <g id="Rectangle_5661" data-name="Rectangle 5661"
                                   transform="translate(-16429 2058) rotate(-90)" fill="none"
                                   stroke="#fff"
                                   stroke-width="1" strokeDasharray="0" opacity="0">
                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                          fill="none"/>
                                </g>
                            </g>
                        </svg>

                    </li>

                </ul>
            </div>

            <Container fluid className={`sustain`}>
                {
                    data?.list && data?.list?.length>0 ?
                        <Swiper
                            Swiper modules={[Autoplay, Pagination, Navigation,EffectFade]}
                            slidesPerView={1}
                            allowTouchMove={true}
                            longSwipesMs={900}
                            speed={900}
                            loop={true}
                            autoHeight={true}
                            effect={"fade"}
                            pagination={{
                                // el: '.swiper-pagination',
                                type: "fraction",
                            }}
                            onBeforeInit={(swiper) => {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                            }}
                            shouldSwiperUpdate={(prev, next) => {
                                if (prev.activeIndex === next.slides.length - 1) {
                                    setButtonDisabled(true);
                                } else {
                                    setButtonDisabled(false);
                                }
                            }}
                            onSlideChange={(s) => handleSliderCurrent()}
                            // onLoad={(s) => handleSliderCurrent()}
                        >
                            <div className={'sustain__top'}>
                                <Title text={data?.title} margin={'0 0 60px 0'} color={`${white}`} />                        {
                                no_slider ? null :   <p><span>{now}</span>/<span>{data?.list?.length}</span></p>
                            }

                                {/*e?.images[0]?.full_path*/}
                            </div>
                            {
                                data?.list && data?.list?.length>0 &&
                                data?.list?.map((element)=>{
                                    return(
                                        <SwiperSlide>
                                            <Row className={'sustainability'} >
                                                <Col md={6} className={'sustainability__left'}>
                                                    <div className={`sustainability__left__data`}>
                                                        <Title text={element?.subtitle} fontSize={58} lineHeight={64} color={`${white}`} mobileFontSize={40} mobileLineHeight={44} fontFamily={`${bold}`} />
                                                        <div className="text split-up">
                                                            {ReactHtmlParser(element?.desc)}
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={6} className={'p-0 '}>
                                                    <div className="sustainability__right">
                                                        <img src={element?.image} alt={'esrs'}/>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </SwiperSlide>
                                    )
                                })
                            }


                            {/*<SwiperSlide>*/}
                            {/*    <Row className={'sustainability'} >*/}
                            {/*        <Col md={6} className={'sustainability__left'}>*/}
                            {/*            <div className={`sustainability__left__data`}>*/}
                            {/*                <Title text={'Industry Leaders in Innovations'} fontSize={58} lineHeight={64} color={`${white}`} mobileFontSize={40} mobileLineHeight={44} fontFamily={`${bold}`} />*/}
                            {/*                <div className="text split-up">*/}
                            {/*                    {ReactHtmlParser(`<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>`)}*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        </Col>*/}
                            {/*        <Col md={6} className={'p-0 '}>*/}
                            {/*            <div className="sustainability__right">*/}
                            {/*                <img src={'/images/dynamic/home/why.jpg'} alt={'esrs'}/>*/}
                            {/*            </div>*/}
                            {/*        </Col>*/}
                            {/*    </Row>*/}
                            {/*</SwiperSlide>*/}
                        </Swiper> : ''
                }

            </Container>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
  position: relative;
  margin-top: -10px;
  padding-left: ${props => props.offset ? props.offset+15+'px' : '90px'};

  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    height: 50%;
    background-color: ${darkBlue};
  }
    
  &.no_slide{
    .title{
      margin-left: 0 !important;
    }
  }
  //navigation
  .navigation {

    ul {
      display: flex;
      //flex-direction: column;

      li {
        cursor: pointer;

        &:first-child {
          margin-bottom: 20px;
          margin-right: 0;
        }

        svg {
          path, #Rectangle_5661 {
            //transition: strokeDasharray 0.3s ease-in-out;
            transition: all 1s cubic-bezier(.25, .74, .22, .99);
          }
        }


        &:hover {
          svg {
            #Rectangle_5661 {
              opacity: 1;

              stroke-dasharray: 140px;
            }

            path {
              stroke: ${hover};
            }
          }
        }
      }
    }
  }
  @media(max-width: 767px){
    padding-left: 0 !important;
    margin-top: 0;
  }
  .swiper-button-prev , .swiper-button-next{
    opacity: 0;
    visibility: hidden;
  }
  .title{
    h2{
      //line-height:60px ;
    }
  }
  ul{
    position: absolute;
    top: 235px;
    left: ${props => props.offset ? props.offset+85+'px' : '180px'};
    z-index: 150;
    display: flex;

    @media(max-width: 992px) and (min-width: 768px){
      left: 40px !important;
      
    }
    li{
      cursor: pointer;
      svg{
        #Ellipse_4378 {
          transition: all 0.7s cubic-bezier(0.4, 0, 0, 1);
          r: 0;
        }

        &:hover {
          #Ellipse_4378 {
            fill: rgb(208, 202, 16);
            transition: all 0.7s cubic-bezier(0.4, 0, 0, 1);
            r: 26px;
          }
          g{
            line{
              stroke: #f9f9f9;
            }
          }
        }
      }
    }
    li:first-child{
      padding-right: 20px;
    }
  }
  .sustain{
    padding-left: 0;
    padding-right: 0;
    &__top{
      position: absolute;
      top: 120px;
      z-index: 150;
      width: 100%;
      display: flex;
      padding-left: 70px;
      padding-right: 100px;
      @media(max-width: 992px) and (min-width: 768px){
        padding-left: 50px;
        padding-right: 50px;

      }

      .subtitle:after{
        background: #f9f9f9;
      }
      p{
        color: #f9f9f9;
      }
    }
    .sustainability{
      margin: 0;
      &__left{
        background-color: ${hover};
        margin-left: 0;
        &__data{
          position: relative;
          // padding-right: ${props => props.offset ? props.offset+115+'px' : '180px'};
          // padding-left: ${props => props.offset ? props.offset+115+'px' : '180px'};
          @media(max-width: 992px) and (min-width: 768px){
            padding-left: 35px;
            padding-right: 35px;

          }
          h2{
            border-bottom: none !important;
          }
          ul{
            position: relative;
            left: unset;
            top: unset;
            margin-left: 15px;
            margin-top: 0;
         li{
           list-style: disc;
          
         }
            flex-direction: column;
          }
          padding-right:85px;
          padding-left: 55px;
          margin-top: 230px;
          padding-bottom: 80px;
          
          &.no_slide{
            margin-left: 0px !important;
          }
          .title{
            margin-bottom: 60px;
            width: 100%;
            margin-left: 190px;
            z-index: 5;
          }
          .text, p{
            margin-bottom: 24px;
            color: ${white};
          }
        }
      }
      &__right{
        position: relative;
        padding-top: calc(620 / 634 * 100%);
        height: 100%;
        img{
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }
  }
  
  
  @media(max-width: 767px) {
    .sustain{
      &__top{
        top: 40px;
        padding: 0 15px;
        width: 100%;
      }
      .sustainability{
        flex-direction: column-reverse;
        margin: 0;
        &__left{
          &__data{
            margin-top: 0;
            margin-bottom: 120px;
            padding: 0px;
            .title{
              margin-left: 0;
              margin-bottom: 20px;
              margin-top: -40px;
              width: initial;
            }
          }
        }
        &__right{
          position: relative;
          padding-top: calc(370 / 375 * 100%);
          img{
            position: absolute;
            top: 0;
            left: 0;
            height: 100%; 
            width: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
  @media(max-width: 767px){
    top: 0;
    margin-bottom: 0;
  ul{
    position: absolute;
    top: 175px;
    left: 15px;
    z-index: 150;
  }
    .navigation{
      ul{
        top: 250px;
      }
    }
}





  .swiper-pagination {
    opacity: 0;
    visibility: hidden;
  }
  @media(max-width: 992px) and (min-width: 768px){
    padding: 0 !important;
    .sustainability__left__data{
      padding-right: 40px !important;
      padding-left: 40px !important;
    }
  }
`;

export default MyComponent;
